function CookieCompliance() {
  var self = this

  function setCookie(name, value) {
    var expires = new Date()
    expires.setTime(expires.getTime() + (365 * 24 * 60 * 60 * 1000))
    document.cookie = name + '=' + value + '; expires=' + expires.toUTCString()
  }

  function getCookie(name) {
    var keyValue = document.cookie.match('(^|) ?' + name + '=([^]*)(|$)')
    return keyValue ? keyValue[2] : null
  }

  function accept(cookieType) {
    $.ajax({
      type: 'POST',
      url: '/cookie-compliance/accept',
      contentType: 'application/json',
      data: JSON.stringify({cookieType: cookieType}),
      dataType: 'json'
    })
      .done(function () {
        setCookie('luminor-pension-cookie-compliance', cookieType)
        $('#cookie-compliance').hide()
        location.reload()
      })
  }

  self.init = function() {
  }
}